module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C884"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("ILLUSTRATIONS ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C941"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "html/images/Image_8_0.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "C1192"
  }, [_vm._v("Illustrations discussed in this book can be viewed at high resolution at "), _c('a', {
    attrs: {
      "href": "http://mappingthenation.com",
      "target": "_blank"
    }
  }, [_vm._v("mappingthenation.com. ")])]), _vm._v(" "), _c('p', {
    staticClass: "C978"
  }, [_c('a', {
    attrs: {
      "href": "#/html/07_Introduc#id_5"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("0.1")]), _vm._v("Map of contributors to California’s Proposition 8 (2008) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C977"
  }, [_c('a', {
    attrs: {
      "href": "#/html/09_1__The_G#page_32"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("1.1")]), _vm._v("Emma Willard’s “picture” of world history (1835) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C977"
  }, [_c('a', {
    attrs: {
      "href": "#/html/09_1__The_G#id_74"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("1.2")]), _vm._v("Emma Willard’s “American Temple of Time” (1860) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C977"
  }, [_c('a', {
    attrs: {
      "href": "#/html/09_1__The_G#id_77"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("1.3")]), _vm._v("Emma Willard’s “tree of time” (1864) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C977"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_2__Captu#page_45",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("2.1")]), _vm._v("Detail from Johann Georg Kohl’s map of exploration of the West Coast (1857) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C977"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_2__Captu#page_48",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("2.2")]), _vm._v("Detail from US Coast Survey’s “Historical Sketch of the Rebellion” (1864) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C977"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_2__Captu#page_49",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("2.3")]), _vm._v("Detail of legend from US Coast Survey’s “Historical Sketch of the Rebellion” (1864) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C977"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_2__Captu#id_122",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("2.4")]), _vm._v("Detail from Rufus Blanchard’s “Historical Map of the United States” (1876) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C977"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_2__Captu#page_62",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("2.5")]), _vm._v("Albert Bushnell Hart’s map of territorial growth in the United States (1891) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C977"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_2__Captu#page_66",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("2.6")]), _vm._v("John F. Smith’s map of American “historical geography” (1888) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C977"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_2__Captu#id_137",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("2.7")]), _vm._v("Detail from Smith’s map ")])]), _vm._v(" "), _c('p', {
    staticClass: "C977"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_2__Captu#id_153",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("2.8")]), _vm._v("Maps of land use from "), _c('em', [_vm._v("Atlas of the Historical Geography of the United States ")]), _vm._v("(1932) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C977"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_3__Disea#page_82",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("3.1")]), _vm._v("Alexander von Humboldt’s chart of equal temperatures (1817) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C977"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_3__Disea#id_168",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("3.2")]), _vm._v("Legend from William Woodbridge’s “Chart of the Inhabited World” (1821) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C977"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_3__Disea#page_85",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("3.3")]), _vm._v("Detail of William Woodbridge’s isothermal and agricultural chart of the world (1823) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C977"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_3__Disea#page_87",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("3.4")]), _vm._v("Detail from Amariah Brigham’s world map of cholera (1832) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C977"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_3__Disea#page_91",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("3.5")]), _vm._v("Detail of Thomas Buckler’s map of the 1849 cholera epidemic in Baltimore (1851) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C977"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_3__Disea#page_95",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("3.6")]), _vm._v("Edward Barton’s map of the 1854 yellow fever epidemic in New Orleans (1855) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C977"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_3__Disea#page_96",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("3.7")]), _vm._v("Detail from Barton’s map of yellow fever ")])]), _vm._v(" "), _c('p', {
    staticClass: "C977"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_3__Disea#id_214",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("3.8")]), _vm._v("Detail from Samuel Forry’s map of climate patterns in the United States (1842) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C977"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_3__Disea#page_103",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("3.9")]), _vm._v("The US Army Surgeon General’s map of average summer temperatures (1855) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C976"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_3__Disea#id_226",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rs"
  }, [_vm._v("3.10")]), _vm._v("The US Army Surgeon General’s map of annual rainfall (1855) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C976"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_3__Disea#id_228",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rs"
  }, [_vm._v("3.11")]), _vm._v("Joseph Henry’s map of agricultural potential (ca. 1856) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C976"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_3__Disea#page_113",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rs"
  }, [_vm._v("3.12")]), _vm._v("William Gilpin’s map of the “isothermal zodiac,” or zone of equal temperature (1860) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C977"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_4__Slave#id_258",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("4.1")]), _vm._v("Francis Bicknell Carpenter’s "), _c('em', [_vm._v("First Reading of the Emancipation Proclamation of President Lincoln ")]), _vm._v("(1864) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C977"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_4__Slave#page_121",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("4.2")]), _vm._v("The US Coast Survey’s map of Southern slavery (1861) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C977"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_4__Slave#id_278",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("4.3")]), _vm._v("August Petermann’s map of slavery (1855) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C977"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_4__Slave#id_284",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("4.4")]), _vm._v("John Jay’s map of slavery in the territories (ca. 1856) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C977"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_4__Slave#page_131",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("4.5")]), _vm._v("Presidential campaign map comparing the free and slave states (1856) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C977"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_4__Slave#page_134",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("4.6")]), _vm._v("The US Coast Survey’s map of slavery in Virginia (1861) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C977"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_4__Slave#page_138",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("4.7")]), _vm._v("Detail of “Kanawha” (West Virginia), from US Coast Survey map of slavery (1861) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C977"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_4__Slave#id_324",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("4.8")]), _vm._v("Legend from Frederick Law Olmsted’s map of slavery and cotton production (1861) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C977"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_4__Slave#page_149",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("4.9")]), _vm._v("Detail from Olmsted’s map of cotton production ")])]), _vm._v(" "), _c('p', {
    staticClass: "C976"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_4__Slave#page_150",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rs"
  }, [_vm._v("4.10")]), _vm._v("Legend from John Mallet’s map of cotton production (1862) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C976"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_4__Slave#page_152",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rs"
  }, [_vm._v("4.11")]), _vm._v("Detail from Edward Atkinson’s map of cotton production (1863) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C977"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_5__The_C#id_376",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("5.1")]), _vm._v("US Census Office’s map of “foreign population” (1872) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C977"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_5__The_C#id_379",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("5.2")]), _vm._v("US Census Office’s map of “colored population” (1872) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C977"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_5__The_C#id_383",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("5.3")]), _vm._v("US Census Office’s map of population density (1872) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C977"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_5__The_C#page_175",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("5.4")]), _vm._v("Francis Amasa Walker’s proportional map of foreign population from the "), _c('em', [_vm._v("Statistical Atlas of the United States ")]), _vm._v("(1874) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C977"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_5__The_C#id_396",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("5.5")]), _vm._v("Detail from Walker’s map of foreign population from the "), _c('em', [_vm._v("Statistical Atlas of the United States ")]), _vm._v("(1874) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C977"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_5__The_C#page_177",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("5.6")]), _vm._v("Francis Amasa Walker’s map of illiteracy from the "), _c('em', [_vm._v("Statistical Atlas of the United States ")]), _vm._v("(1874) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C977"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_5__The_C#id_405",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("5.7")]), _vm._v("Detail from Francis Amasa Walker’s map of white population and Indian reservations (1874) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C977"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_5__The_C#page_181",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("5.8")]), _vm._v("Detail from Adolph von Steinwehr’s map of river systems (1874) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C977"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_5__The_C#page_183",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("5.9")]), _vm._v("US Provost Marshal General Bureau’s map of syphilis among drafted men (1875) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C976"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_5__The_C#id_420",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rs"
  }, [_vm._v("5.10")]), _vm._v("Julius Hilgard’s map of the shifting center of population from the "), _c('em', [_vm._v("Statistical Atlas of the United States ")]), _vm._v("(1874) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C976"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_5__The_C#page_190",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rs"
  }, [_vm._v("5.11")]), _vm._v("Jedediah Hotchkiss’s map of population in Virginia ")])]), _vm._v(" "), _c('p', {
    staticClass: "C976"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_5__The_C#page_191",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rs"
  }, [_vm._v("5.12")]), _vm._v("Jedediah Hotchkiss’s map of the black population in Virginia, with annotations ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eff378c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/05_List_of.vue
// module id = 66
// module chunks = 0